import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
	selector: 'app-input-field',
	templateUrl: './input-field.component.html',
	styleUrls: ['./input-field.component.scss'],
})
export class InputFieldComponent implements OnInit {
	@HostBinding('class') class = 'input-field';
	@Input() control: UntypedFormControl;
	@Input() autocomplete = 'on';
	@Input() type = 'text';
	@Input() icon: string = null;
	@Input() label = '';
	@Input() name = '';
	@Input() placeholder = '';

	constructor() {}

	ngOnInit(): void {}

	showErrors() {
		const { dirty, touched, errors } = this.control;

		return dirty && touched && errors;
	}
}
